const it = {
    appNav: {
        admin: {
            training: "Addestramento",
        },
    },
    splashScreen: {
        intro: "PARLA CON",
        welcome: "Benvenuto in IVE",
        scenarioSelection: "Elige el escenario"
    },
    statistics: {
        goToStatistics: "Vai alle statistiche",
        dialogs: {
            header: "Dialoghi",
            description: "Vedi le informazioni sui dialoghi: Topics più richiesti, domande mal interpretate, etc...",
        },
        documents: {
            header: "Documenti",
            description: "Vedi le informazioni sui documenti: Topics più richiest, documenti più richiesti, etc...",
        },
        classification: {
            header: "Classificazione",
            description: "Vedi le informazioni riguardo la Classificazione: risulti dell'addestramento, accuratezza, etc...",
        },
        mail: {
            header: "Posta elettronica",
            description: "Vedi le informazioni riguardo il routing automatico: risulti della classificazione, accuratezza, etc...",
        },
    },
    account: {
        title: "Account",
    },
    settings: {
        title: "Impostazioni",
        save: "Salva",
        language: {
            header: "Lingua",
            chooseLanguage: "Scegli lingua",
        },
        notificationsType: {
            header: "Modalità notifiche",
            chooseNotificationsType: "Scegli la modalità per le notifiche",
        },
        dialogicPlatform: {
            header: 'Dialoghi',
            chooseLanguage: "Scegli la lingua",
            engine: {
                chooseEngine: "Scegli il motore dialogico"
            },
        },
        emailRouting: {
            header: "Posta elettronica",
            enable: "Abilita il Mail Routing",
            description: "Permetti la classificazione delle e-mails per l'inoltro automatico",
        },
        webInformationRetrieval: {
            header: "Web Radar",
            enable: "Abilita il Web Radar",
            description: "Permetti l'analisi dei siti web più rilevanti per l'ottenimento automatico di infomazioni",
        },
        imageCaptioning: {
            header: "Descrizione di immagini",
            enable: "Abilita Descrizione di immagini",
            description: "Permette l'analisi di immagini per ottenre descrizioni testuali",
        },
    },
    globalControls: {
        notifications: {
            header: "Notifiche",
            noNotifications: "Nessuna notifica",
            deleteAll: "Cancella tutto",
            content: {
                showMore: "Clicca per mostrare di più...",
                showLess: "Clicca per mostrare di meno...",
            },
        },
        fileInput: {
            dragAndDrop: "Trascina il file oppure clicca qui per sceglierlo dal tuo PC!",
            selectFile: "Scegli un file",
            uploadFiles: "Carica i Files"
        },
        fileViewer: {
            latestVersion: "Ultima Versione",
            lastModified: "Ultima modifica",
            author: "Autore",
            version: "Versione",
        },
    },
    training: {
        ontology: {
            title: "Ontologia",
            upload: {
                titlePage: "Carica il tuo dizionario",
                subtitle: "Carica un file csv",
                uploadMessage: "Carica ontologia",
                buttonTitle: "Carica",
            },
        },
        classes: {
            title: "Classi",
            upload: {
                uploadMessage: "Carica",
                buttonTitle: "Carica",
            },
            addDocuments: "Aggiungi documenti",
            reset: "Reset Addestramento",
            selectClass: {
                chooseClass: "Scegli la classe",
                addClass: "Aggiungi una nuova classe",
                description: "Digita il nome della nuova classe che vuoi creare.",
                name: "Nome della nuova classe",
                confirm: "Conferma",
                close: "Chiudi"
            },
            wait: "Attendi la fine del caricamento per favore...",
            navigationDrawer: {
                deleteClass: "Elimina Classe",
                keywords: "Keywords",
            },
            deleteDialog: {
                title: "Elimina Classe",
                text: "Sei sicuro di vole eliminare questa classe?",
                yes: "Sì",
                no: "No"
            },
            chart: {
                title: "Addestramento del classificatore testuale",
                description: "Questo grafico mostra le classi sulle quali il classificatore è addestrato. È possibile interagire e vedere come le classi sono correlate tra loro.",
                text: "Questo grafico mostra le classi sulle quali il classificatore è addestrato. È possibile interagire e vedere come le classi sono correlate tra loro.",
            },
        },
        conversation: {
            title: "Conversazione",
            intent: "Intenti",
            createIntent: {
                name: "Crea un intento",
                description: "Scrivi il nome del nuovo intento",
                label: "Nome del nuovo intento",
                save: "Salva",
                close: "Chiudi"

            },
            questions: "Domande",
            answers: "Risposte",
            attachments: "Allegati",
            save: "Salva",
            delete: "Elimina",
            innovation: {
                uploadTitle: "Carica il file con le startup",
                uploadSubtitle: "Carica un file xls o xlsx",
                uploadMessage: "Carica file",
                uploadButton: "Carica file"
            }

        },
        files: {
            title: "Carica i file",
            otherResults: "Altri risultati",
            upload: {
                titlePage: "Carica i tuoi documenti",
                subtitle: "Provvederò a classificarli!",
                uploadMessage: "Carica",
                buttonTitle: "Carica",
            },
            toolbar: {
                storage: "Archivio",
                filter: {
                    tip: "Filtra per nome",
                    label: "Filtra...",
                    caseSensitive: "Filtraggio case sensitive",
                },
                createNew: {
                    tip: "Crea un nuovo documento",
                    windowTitle: "Nuovo Documento",
                    subToolbar: {
                        save: "Salva",
                    },
                },
                uploadFiles: {
                    tip: "Carica documenti",
                },
                deleteAll: {
                    tip: "Elimina tutti i documenti",
                },
            },
            fileResult: {
                deleteAll: "Elimina tutto",
            },
            base: {
                deleteAllTitle: "Eliminare tutti i documenti?",
                deleteAllDescription: "Sei sicuro di voler eliminare tutti i documenti?",
                confirmDelete: "Elimina tutto",
                cancelDelete: "Annulla",
                emptyMessage_1: "Nessun file.",
                emptyMessage_2: "Clicca sul bottone di caricamento",
                emptyMessage_3_1: "per caricare dei documenti.",
                emptyMessage_3: "per caricare o clicca sull'icona di creazione",
                emptyMessage_4: "per crearne uno nuovo.",
            },
        },
    },
    testing: {
        classes:{
            title: "Vuoi provare il tuo calssificatore?",
            description: "Qui puoi testare il tuo classificatore",
            upload: {
                uploadMessage: "Classifica",
                buttonTitle: "Classifica",
            },
            table: {
                class: "Classe",
                confidence: "Confidenza",
                noData: "Nessun dato disponibile"
            },
        },
        search: {
            title: "Cerca",
        },
        talk: {
            title: "Parla con me",
        },
        documentSimilarity: {
            title: "Similarità tra documenti",
            upload: {
                titlePage: "Similarità tra documenti",
                uploadMessage: "Carica un documento",
                buttonTitle: "Verifica similarità",
            }
        },
    },
};

export default it;
